// extracted by mini-css-extract-plugin
export var backdropBlur = "_bz-0";
export var contentCard = "_bz-5";
export var frame = "_bz-2";
export var image = "_bz-4";
export var imagePane = "_bz-3";
export var modal = "_bz-1";